// Generated types for Part
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PartReadAPI extends RFLPElementReadAPI {
}

export interface PartWriteAPI extends RFLPElementWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PartReadAPISchemaObject = RFLPElementReadAPISchemaObject.extend({}).passthrough();
export const PartReadAPISchema: z.ZodType<PartReadAPI> = PartReadAPISchemaObject;

export const PartWriteAPISchemaObject = RFLPElementWriteAPISchemaObject.extend({}).passthrough();
export const PartWriteAPISchema: z.ZodType<PartWriteAPI> = PartWriteAPISchemaObject;
